import { memo } from 'react';
import styled from 'styled-components';
import { PiClipboardText } from 'react-icons/pi';
import { CollectForm_GetListWithUUIDs_ResponseItem } from '~/common/typescript/apis/CollectFormAPIs';

const ClipboardIcon = PiClipboardText as React.ComponentType<{ style?: React.CSSProperties }>;

interface CollectFormGridProps {
  forms: CollectForm_GetListWithUUIDs_ResponseItem[];
  onSelectForm: (formUuid: string, formData?: CollectForm_GetListWithUUIDs_ResponseItem) => void;
  onGoToFormsTab?: () => void;
}

const CollectFormGrid = ({ forms, onSelectForm, onGoToFormsTab }: CollectFormGridProps) => {
  if (forms.length === 0) {
    return (
      <EmptyState>
        <EmptyIcon><ClipboardIcon style={{ color: '#9ca3af' }} /></EmptyIcon>
        <EmptyTitle>Chưa có biểu mẫu nào</EmptyTitle>
        <EmptyDescription>
          Tạo biểu mẫu mới để bắt đầu thu thập dữ liệu
        </EmptyDescription>
        {onGoToFormsTab && (
          <EmptyButton onClick={onGoToFormsTab}>
            Tạo biểu mẫu mới
          </EmptyButton>
        )}
      </EmptyState>
    );
  }

  return (
    <Container>
      <GridTitle>Chọn biểu mẫu để xem dữ liệu thu thập:</GridTitle>
      <Grid>
        {forms.map((form) => (
          <FormCard
            key={form.uuid}
            onClick={() => onSelectForm(form.uuid, form)}
          >
            <FormIcon><ClipboardIcon style={{ color: '#3b82f6' }} /></FormIcon>
            <FormName>{form.name || 'Chưa có tên'}</FormName>
            {(form as any).item_count > 0 && (
              <FormCount>{(form as any).item_count} bản ghi</FormCount>
            )}
            {form.description && (
              <FormDescription>{form.description}</FormDescription>
            )}
          </FormCard>
        ))}
      </Grid>
    </Container>
  );
};

export default memo(CollectFormGrid);

const Container = styled.div`
  padding: 16px;
  height: 100%;
  overflow-y: auto;
`;

const GridTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
`;

const FormCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #3b82f6;
  }
`;

const FormIcon = styled.div`
  font-size: 32px;
  margin-bottom: 8px;
`;

const FormName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
`;

const FormCount = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

const FormDescription = styled.div`
  font-size: 11px;
  color: #9ca3af;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  height: 100%;
`;

const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.3;
`;

const EmptyTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
`;

const EmptyDescription = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 16px;
  max-width: 300px;
`;

const EmptyButton = styled.button`
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #2563eb;
  }
`;
